import styled, { css } from 'styled-components';
import { withProps } from 'recompose';

import FrontshopLink from 'ggApp/shared/containers/FrontshopLink';
import Typography from 'ggApp/shared/components/typography';

const OutterWrap = styled.div`
    display: block;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin-bottom: 18px;
    `}
`;

const Question = styled.label`
    ${({theme}) => css(theme.typography.SuperTinyHeadline)};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-right: 12px;
`;

const AnswerText = styled(Typography)`
    ${({theme}) => css(theme.typography.Paragraph)};
    color: ${({ theme }) => theme.colors.Foreground};
`;

const Indicator = styled.span`
    ${({theme}) => css(theme.typography.SuperTinyHeadline)};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-left: auto;
    align-self: flex-start;
`;

const InnerWrap = styled.div`
    margin: ${({ faqStyle }) => faqStyle === 'faqV2' ? '24px 12px 0px 0px' : '24px 12px 16px 0px' };
    display: flex;
    cursor: pointer;
    align-items: center;
    &:hover {
        ${Question} {
            opacity: 0.5;
        }
        ${Indicator} {
            opacity: 0.5;
        }
    }
`;

const ItemNumber = styled.div`
    min-height: 24px;
    min-width: 24px;
    border-radius: 50%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
    align-self: flex-start;
    background: #f1f1f1;
`;

const ItemNumberText = styled.h3`
    ${({theme}) => css(theme.typography.SuperTinyHeadline)};
`;

const Answer = styled.div`
    box-sizing: content-box;
    transition-property: max-height;
    overflow: hidden;
    transition-duration: ${({ isActive }) => (isActive ? '1s' : '0.5s')};
    transition-timing-function: ${({ isActive }) => (isActive ? 'ease-in-out' : 'cubic-bezier(0, 1, 0, 1)')};
    max-height: ${({ isActive }) => (isActive ? '100vh' : '0vh')};
    ${({theme}) => css(theme.typography.Paragraph)};
    color: ${({accentColor, theme}) => accentColor || theme.colors.Foreground};
    ${({ withIcons }) => withIcons
        && css`
            margin: 0px 64px 0px 36px;
        `}
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin-top: 16px;
    `}
`;

// That will make link relative if it is specified that way
const TextLink = styled(withProps(({ href }) => ({ to: href }))(FrontshopLink))`
    ${({theme}) => css(theme.typography.Paragraph)};

    text-decoration: underline;
    color: ${({ theme }) => theme.colors.Foreground};
    &:hover {
        color: ${({ theme }) => theme.colors['Level 4']};
    }
`;

export {
    OutterWrap,
    InnerWrap,
    ItemNumber,
    ItemNumberText,
    Question,
    AnswerText,
    Indicator,
    Answer,
    TextLink,
};
